
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TEmployeeSummary } from "@/models/employees";
import {
  EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED,
  EMPLOYEE_EMPLOYMENT_STATUS_LEAVING,
  EMPLOYEE_EMPLOYMENT_STATUS_LEAVER,
} from "@/constants/compliance";
import { SUCCES_ICON_TYPE, WARNING_ICON_TYPE } from "@/constants/icons";
import UserTerminatedIcon from "@/assets/images/icons/user-terminated.svg";

const OPTIONS = [
  {
    value: EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED,
    label: EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED,
    circle: SUCCES_ICON_TYPE,
  },
  {
    value: EMPLOYEE_EMPLOYMENT_STATUS_LEAVING,
    label: EMPLOYEE_EMPLOYMENT_STATUS_LEAVING,
    circle: WARNING_ICON_TYPE,
  },
];

@Component({})
export default class EmployeeSummaryDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly employeeSummary!: TEmployeeSummary;

  userTerminatedIcon = UserTerminatedIcon;

  terminateStatus = EMPLOYEE_EMPLOYMENT_STATUS_LEAVER;

  options = OPTIONS;

  status = this.employeeSummary?.working_status || EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED;

  get isTerminated() {
    return this.status === EMPLOYEE_EMPLOYMENT_STATUS_LEAVER;
  }

  @Watch("status")
  updateStatus(status: string) {
    if (status === EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED) return this.$emit("save");

    this.$emit("open-popup");
  }
}
